import { regions, years } from '@/mocks/videos';
import type { FilterState } from '@/utils/video';

interface FilterSidebarProps {
  filters: FilterState;
  subTypes: string[];
  onChange: (patch: Partial<FilterState>) => void;
  onReset: () => void;
}

const popularityOptions = ['全部', '热门', '高分'];

interface GroupProps {
  label: string;
  options: string[];
  value: string;
  onSelect: (value: string) => void;
}

function FilterGroup({ label, options, value, onSelect }: GroupProps) {
  return (
    <div className="mb-6 last:mb-0">
      <h3 className="font-heading text-sm font-semibold text-foreground-950 mb-3">{label}</h3>
      <div className="flex flex-wrap gap-2">
        {options.map((option) => {
          const active = value === option;
          return (
            <button
              key={option}
              type="button"
              onClick={() => onSelect(option)}
              className={`px-3 py-1.5 rounded-md text-xs transition-colors cursor-pointer whitespace-nowrap ${
                active
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-100 text-foreground-700 hover:bg-background-200'
              }`}
            >
              {option}
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default function FilterSidebar({ filters, subTypes, onChange, onReset }: FilterSidebarProps) {
  return (
    <aside className="w-full lg:w-[260px] flex-shrink-0">
      <div className="rounded-lg bg-background-100 border border-background-200 p-5">
        <div className="flex items-center justify-between mb-5">
          <h2 className="font-heading font-semibold text-foreground-950 flex items-center gap-2">
            <i className="ri-filter-3-line text-primary-600"></i>
            筛选
          </h2>
          <button
            type="button"
            onClick={onReset}
            className="text-xs text-foreground-500 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
          >
            重置全部
          </button>
        </div>

        <FilterGroup
          label="类型"
          options={subTypes}
          value={filters.subType}
          onSelect={(value) => onChange({ subType: value })}
        />
        <FilterGroup
          label="地区"
          options={regions}
          value={filters.region}
          onSelect={(value) => onChange({ region: value })}
        />
        <FilterGroup
          label="年份"
          options={years}
          value={filters.year}
          onSelect={(value) => onChange({ year: value })}
        />
        <FilterGroup
          label="热门程度"
          options={popularityOptions}
          value={filters.popularity || '全部'}
          onSelect={(value) => onChange({ popularity: value })}
        />
      </div>
    </aside>
  );
}